
import React, { useEffect, useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

export interface SimpleCaptchaProps {
  onGenerate?: (text: string) => void;
  name?: string;
}

const SimpleCaptcha: React.FC<SimpleCaptchaProps> = ({ 
  onGenerate,
  name
}) => {
  const [captchaText, setCaptchaText] = useState('');
  
  const generateCaptchaText = (): string => {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
    let result = '';
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };
  
  const regenerateCaptcha = () => {
    const newCaptcha = generateCaptchaText();
    setCaptchaText(newCaptcha);
    if (onGenerate) {
      onGenerate(newCaptcha);
    }
  };
  
  useEffect(() => {
    regenerateCaptcha();
  }, []);
  
  return (
    <div className="flex items-center space-x-2">
      <Card className="relative overflow-hidden p-3 bg-gray-100 border-2 min-w-[150px] flex items-center justify-center">
        <div className="select-none text-lg font-bold tracking-widest text-gray-700 font-mono" style={{ 
          letterSpacing: '0.25em',
          textShadow: '1px 1px 2px rgba(0,0,0,0.15)'
        }}>
          {captchaText}
        </div>
        <div className="absolute inset-0 pointer-events-none">
          {/* Random lines for noise */}
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <line x1="0" y1="30%" x2="100%" y2="70%" style={{ stroke: 'rgba(0,0,0,0.1)', strokeWidth: 1 }} />
            <line x1="0" y1="70%" x2="100%" y2="30%" style={{ stroke: 'rgba(0,0,0,0.1)', strokeWidth: 1 }} />
          </svg>
        </div>
      </Card>
      <Button 
        type="button" 
        variant="outline" 
        size="icon"
        onClick={regenerateCaptcha}
        aria-label="Refresh captcha"
      >
        <RefreshCw className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default SimpleCaptcha;
